module.exports = __webpack_public_path__ + "static/img/szafa_27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/szafa_27.jpg
// module id = SoDT
// module chunks = 0